/**
 * 카테고리 관련 API 함수
 */

import type { GetCategoriesResponse } from "@repo/types";
import apiClient from "../lib/apiClient";

/**
 * 카테고리 목록 조회
 *
 * 엔드포인트: GET /api/course/categories
 * - 전체 카테고리 조회 (페이지네이션 없음)
 * - weight 순으로 정렬
 * - 소프트 딜리트: DELETED 상태 자동 제외
 * - 계층 구조 정보 포함 (parentCategoryId, depth)
 *
 * @returns 카테고리 목록
 */
export const getCategories = async (): Promise<GetCategoriesResponse> => {
  try {
    console.log("📤 카테고리 목록 조회 요청: /api/course/categories");
    const response = await apiClient.get<GetCategoriesResponse>("/course/categories");
    console.log("✅ 카테고리 목록 조회 성공:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 카테고리 목록 조회 실패:", error);
    console.warn("⚠️  백엔드 API가 구현되지 않았습니다. 빈 데이터를 반환합니다.");
    // 백엔드 API가 준비되지 않았을 때 빈 데이터 반환
    return { data: [] };
  }
};

